import {
    faBars,
    faClipboard,
    faClipboardList,
    faDatabase,
    faPeopleGroup,
    faUser,
    faUserClock,
    faSliders
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import { NavLink } from 'react-router-dom';
import '../side-bar/sideBarNavigation.css';

const switchNavStyle = ({ isActive }) => (isActive ? 'nav-link active' : 'nav-link');

const SideBarTL = () => {
    const [contentHeight, setContentHeight] = useState();

    useEffect(() => {
        window.addEventListener('resize', updateWidthAndHeight);
        return () => window.removeEventListener('resize', updateWidthAndHeight);
    });

    const updateWidthAndHeight = () => {
        const body = document.body;
        const html = document.documentElement;
        const height = Math.max(
            body.scrollHeight,
            body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
        );
        setContentHeight(document.body.clientHeight);
    };
    return (
        <Container className="sidebarContainer">
            <Nav className="flex-column sideNav" style={{ height: contentHeight }}>
                <Nav.Link href="/home">
                    <FontAwesomeIcon icon={faBars} size="sm" /> <span>Dashboard</span>
                </Nav.Link>
                <NavLink className={switchNavStyle} to="/clients" eventkey="link-3">
                    <FontAwesomeIcon icon={faUser} size="sm" />
                    <span>Clients</span>
                </NavLink>
                <NavLink className={switchNavStyle} to="/job-notification-batches" eventkey="link-job-notification">
                    <FontAwesomeIcon icon={faClipboardList} size="sm" />
                    <span>Job Notifications</span>
                </NavLink>
                <NavLink className={switchNavStyle} to="/candidates" eventkey="link-3">
                    <FontAwesomeIcon icon={faUser} size="sm" />
                    <span>Candidates</span>
                </NavLink>
                <NavLink className={switchNavStyle} to="/unapproved-candidates" eventkey="link-3">
                    <FontAwesomeIcon icon={faUserClock} size="sm" />
                    <span>Approval Requested Candidates</span>
                </NavLink>
                <NavLink className={switchNavStyle} to="/users" eventkey="link-3">
                    <FontAwesomeIcon icon={faUser} size="sm" />
                    <span>User Management</span>
                </NavLink>
                <NavLink className={switchNavStyle} to="/candidate-assignment" eventkey="link-3">
                    <FontAwesomeIcon icon={faUser} size="sm" />
                    <span>Candidate Assignments</span>
                </NavLink>
                <NavLink className={switchNavStyle} to="/assigned-candidates-tl" eventkey="link-3">
                    <FontAwesomeIcon icon={faUser} size="sm" />
                    <span>Assigned Candidates</span>
                </NavLink>
                <NavLink className={switchNavStyle} to="/master-data" eventkey="link-3">
                    <FontAwesomeIcon icon={faSliders} size="sm" />
                    <span>Master Data</span>
                </NavLink>
            </Nav>
        </Container>
    );
};

export default SideBarTL;